// extracted by mini-css-extract-plugin
export var nutritionBox = "recipeCard-module--nutrition-box--2fd44";
export var photosLabel = "recipeCard-module--photos-label--01a2b";
export var rating = "recipeCard-module--rating--dea3f";
export var ratingText = "recipeCard-module--rating-text--35fed";
export var recipe = "recipeCard-module--recipe--e2c96";
export var recipeImageBlock = "recipeCard-module--recipe-image-block--9d3c4";
export var recipeImageCaption = "recipeCard-module--recipe-image-caption--a5863";
export var recipeInfo = "recipeCard-module--recipe-info--44f15";
export var recipeInfoCookTime = "recipeCard-module--recipe-info-cook-time--ba9b7";
export var recipeInfoHeading = "recipeCard-module--recipe-info-heading--59660";
export var recipeInfoPrepTime = "recipeCard-module--recipe-info-prep-time--f26e3";
export var recipeInfoTotalTime = "recipeCard-module--recipe-info-total-time--1ffab";
export var recipeInfoYield = "recipeCard-module--recipe-info-yield--d3f69";
export var recipeIngredient = "recipeCard-module--recipe-ingredient--1ae8b";
export var recipeIngredients = "recipeCard-module--recipe-ingredients--90733";
export var recipeIngredientsHeading = "recipeCard-module--recipe-ingredients-heading--39a1d";
export var recipeIngredientsHeadingBox = "recipeCard-module--recipe-ingredients-heading-box--56bbe";
export var recipeIngredientsInnerBox = "recipeCard-module--recipe-ingredients-inner-box--45ce7";
export var recipeIngredientsList = "recipeCard-module--recipe-ingredients-list--49184";
export var recipeIngredientsRichText = "recipeCard-module--recipe-ingredients-rich-text--17dbf";
export var recipeInstruction = "recipeCard-module--recipe-instruction--5f60b";
export var recipeInstructionText = "recipeCard-module--recipe-instruction-text--e9cdd";
export var recipeInstructionsHeading = "recipeCard-module--recipe-instructions-heading--e3e75";
export var recipeInstructionsHeadingBlock = "recipeCard-module--recipe-instructions-heading-block--a6abd";
export var recipeInstructionsList = "recipeCard-module--recipe-instructions-list--9d229";
export var recipeNote = "recipeCard-module--recipe-note--a84d8";
export var recipeNotes = "recipeCard-module--recipe-notes--af26e";
export var recipeNotesHeading = "recipeCard-module--recipe-notes-heading--aaf21";
export var recipeNotesInnerBox = "recipeCard-module--recipe-notes-inner-box--f87ff";
export var recipeTitle = "recipeCard-module--recipe-title--0b133";
export var switchOn = "recipeCard-module--switch-on--ef285";
export var toggleSwitchContainer = "recipeCard-module--toggle-switch-container--f09b5";
export var toggleSwitchLabel = "recipeCard-module--toggle-switch-label--e728b";
export var toggleSwitchLabelHideMobile = "recipeCard-module--toggle-switch-label-hide-mobile--4150a";